"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _settings = require("@/settings");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 权限判断函数
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  name: '',
  status: ''
};
var _default = exports.default = {
  name: 'CouponUser',
  filters: {
    failFilter: function failFilter(status) {
      var statusMap = {
        receive: '自己领取',
        send: '后台发送',
        give: '满赠',
        new: '新人',
        buy: '买赠送'
      };
      return statusMap[status];
    },
    statusFilter: function statusFilter(status) {
      var statusMap = {
        0: '未使用',
        1: '已使用',
        2: '已过期'
      };
      return statusMap[status];
    }
  },
  data: function data() {
    return {
      Loading: false,
      roterPre: _settings.roterPre,
      imgList: [],
      tableFromIssue: Object.assign({}, tableFroms),
      issueData: {
        data: [],
        total: 0
      },
      name: '',
      loading: false,
      options: []
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:coupon:user:page:list'])) this.getIssueList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleSearchList: function handleSearchList() {
      this.tableFromIssue.page = 1;
      this.getIssueList();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFromIssue = Object.assign({}, tableFroms);
      this.name = '';
      this.handleSearchList();
    },
    // 列表
    getIssueList: function getIssueList() {
      var _this = this;
      this.Loading = true;
      this.tableFromIssue.name = encodeURIComponent(this.name);
      (0, _marketing.couponUserListApi)(this.tableFromIssue).then(function (res) {
        _this.issueData.data = res.list;
        _this.issueData.total = res.total;
        // this.issueData.data.map((item) => {
        //   this.imgList.push(item.user.avatar)
        // })
        _this.Loading = false;
      }).catch(function (res) {
        _this.Loading = false;
        _this.$message.error(res.message);
      });
    },
    pageChangeIssue: function pageChangeIssue(page) {
      this.tableFromIssue.page = page;
      this.getIssueList();
    },
    handleSizeChangeIssue: function handleSizeChangeIssue(val) {
      this.tableFromIssue.limit = val;
      this.getIssueList();
    }
  }
};